import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import AsistenciasView from './AsistenciasView';

const AsistenciasModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.asistenciasDiarias}
      routes={[ROUTES.controlEstudios]}
    >
      <AsistenciasView />
    </ContainerTemplate>
  );
};

export default AsistenciasModule;
